import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row header\"><div class=\"cell\"> Delivery date </div><div class=\"cell\"> Amount </div><div class=\"cell\"> Created at </div><div class=\"cell\"> Updated at </div><div class=\"cell\"> Cancel? </div></div>", 1)
const _hoisted_4 = { class: "cell" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = { class: "cell" }
const _hoisted_8 = { class: "cell" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.delivery_date.replaceAll("-", ".")), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.amount), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatDate(item.created_at)), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatDate(item.updated_at)), 1),
            _createElementVNode("div", _hoisted_8, [
              (item.confirmed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Not possible, ordered! "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn-action red",
                    onClick: ($event: any) => (_ctx.cancelOrder(item))
                  }, "cancel", 8, _hoisted_10))
            ])
          ]))
        }), 128))
      ])
    ]),
    (_ctx.orders.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " No Data "))
      : _createCommentVNode("", true)
  ]))
}